<template>
  <div class="finish">

    <div class="finish-state">
      <i class="el-icon-circle-check finish-icon"></i>
      <h4 >{{ disabled ? $t('lang.查看完毕') : $t('lang.创作完成') }}</h4>
    </div>

    <div class="btn-box">
      <template v-if="!disabled">
        <el-button  type="primary" @click="$emit('edit')">{{ $t('lang.编辑') }}</el-button>
        <el-button type="primary"  @click="$emit('preview')">{{ $t('lang.预览') }}</el-button>
        <el-button type="success" @click="$router.back()">{{ $t('lang.确认完成') }}</el-button>
      </template>

      <el-button @click="$router.back()">{{ $t('lang.返回') }}</el-button>
    </div>

  </div>
</template>

<script>
export default {
  name: "RecipeFinishForm",
  props: {
    status: {
      type: String,
      default: 'add'
    },
  },
  data() {
    return {
      disabled: false,
      api: {
        detail: this.$api.recipe.detail,
      }
    }
  },
  watch: {
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit')
    }
  }
}
</script>

<style scoped>

.finish {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.finish-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.finish-icon {
  font-size: 80px;
  color: #42bd83;
}

.btn-box {
  margin: 24px 0;
}

</style>
